import { getIn, useFormikContext } from 'formik';
import React from 'react';
import {Input } from 'reactstrap'
const TimeSpan = ({ id }) =>{
    const { values, setFieldValue } = useFormikContext();
    const setTimespan = (value) => setFieldValue(id,value);
    const timespan = getIn(values,id)
    var reg = new RegExp('^[0-9:]+$');
    const change = (e)=>{
        const val = e.target.value;
        const bits = val.split(':');
        if (val && !reg.test(val)){
            return;
        }
        if (bits.length === 0){
            setTimespan()
        }
        if (bits.length === 1){
            if (!timespan || timespan.length>val.length){
                setTimespan(val);
            }else {
                const time = bits[0];
                if (time.length > 2) {
                    const hours = time.substring(0, time.length - 2);
                    const minutes = time.substring(time.length - 2);
                    setTimespan(hours + ':' + minutes);
                } else {
                    if (time.length === 2) {
                        setTimespan(bits[0]+":")
                    }
                }
            }
        }
        if (bits.length === 2){
            const time = bits[1];
            if (time.length > 2){
              return;

            }else{
                setTimespan(bits[0]+':'+bits[1]);

            }
        }
    }
    return <Input
            name="number"
            component="input"
            type="text"
            placeholder="HH:MM"
            onChange={change}
            value={timespan}
     />
}


export default TimeSpan;